/**
 * Christmas Countdown Block Script
 * Timezone-aware countdown timer
 */

(function() {
    'use strict';

    function initCountdown(block) {
        const targetDateStr = block.getAttribute('data-target-date');
        const showDays = block.getAttribute('data-show-days') === '1';
        const showHours = block.getAttribute('data-show-hours') === '1';
        const showMinutes = block.getAttribute('data-show-minutes') === '1';
        const showSeconds = block.getAttribute('data-show-seconds') === '1';

        const counters = block.querySelector('.christmas-countdown__counters');
        const finishedMessage = block.querySelector('.christmas-countdown__finished');

        // Parse target date in user's local timezone
        // Add midnight time to the date
        const targetDate = new Date(targetDateStr + 'T00:00:00');

        function updateCountdown() {
            // Get current time in user's timezone
            const now = new Date();
            
            // Calculate difference in milliseconds
            const difference = targetDate.getTime() - now.getTime();

            // If countdown is finished
            if (difference <= 0) {
                if (counters) counters.style.display = 'none';
                if (finishedMessage) finishedMessage.style.display = 'block';
                return false; // Stop the interval
            }

            // Calculate time units
            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);

            // Update display
            updateUnit(block, 'days', days, showDays);
            updateUnit(block, 'hours', hours, showHours);
            updateUnit(block, 'minutes', minutes, showMinutes);
            updateUnit(block, 'seconds', seconds, showSeconds);

            return true; // Continue the interval
        }

        function formatCountdownNumber(unit, value) {
            const number = Math.max(0, Math.floor(Number(value) || 0));
            if (unit === 'days') {
                return String(number);
            }
            return String(number).padStart(2, '0');
        }

        function updateUnit(block, unit, value, shouldShow) {
            if (!shouldShow) return;

            const unitElement = block.querySelector(`.countdown-unit[data-unit="${unit}"]`);
            if (!unitElement) return;

            const numberElement = unitElement.querySelector('.countdown-number');
            if (!numberElement) return;

            const currentValue = numberElement.textContent;
            const newValue = formatCountdownNumber(unit, value);

            if (currentValue !== newValue) {
                // Add animation class
                numberElement.classList.add('counting');
                
                // Update value
                numberElement.textContent = newValue;
                
                // Remove animation class after animation completes
                setTimeout(() => {
                    numberElement.classList.remove('counting');
                }, 600);
            }

            // Update progress ring if present
            const progressRing = unitElement.querySelector('.progress-ring__progress');
            if (progressRing) {
                const maxValue = parseFloat(progressRing.getAttribute('data-max'));
                const percentage = (value / maxValue) * 100;
                const circumference = 2 * Math.PI * 45; // radius = 45
                const offset = circumference - (percentage / 100) * circumference;
                progressRing.style.strokeDashoffset = offset;
            }
        }

        // Initial update
        if (updateCountdown()) {
            // Update every second
            const interval = setInterval(() => {
                if (!updateCountdown()) {
                    clearInterval(interval);
                }
            }, 1000);

            // Store interval ID for cleanup
            block.countdownInterval = interval;
        }
    }

    // Initialize all countdown blocks on page
    function initAllCountdowns() {
        const blocks = document.querySelectorAll('.christmas-countdown');
        blocks.forEach(block => {
            // Clear existing interval if any
            if (block.countdownInterval) {
                clearInterval(block.countdownInterval);
            }
            initCountdown(block);
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllCountdowns);
    } else {
        initAllCountdowns();
    }

    // For WordPress block editor
    if (typeof acf !== 'undefined') {
        acf.addAction('render_block_preview/type=christmas-countdown', initAllCountdowns);
    }

    // Cleanup on page unload
    window.addEventListener('beforeunload', () => {
        const blocks = document.querySelectorAll('.christmas-countdown');
        blocks.forEach(block => {
            if (block.countdownInterval) {
                clearInterval(block.countdownInterval);
            }
        });
    });

})();
